import React, { useEffect, useState, useRef } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { toast } from '../CommonComponents/ToastComponent/toast'
import { ExcelRenderer } from 'react-excel-renderer'
import DragDropFileUpload from '../CommonComponents/DragDropFileUpload'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { uploadData, testFuseJsSettings } from '../../redux/actions/upload'
import { clearUploadData } from '../../redux/actions/upload'
import MatchComponent from '../UploadComponent/match'
import PreviewComponent from '../UploadComponent/preview'
import FuseJsSettings from './fuseJsSettings'
import { Radio, RadioGroup } from 'rsuite';
import { checkIsEmailValid, checkIsPhoneNumberValid, getAbbreviatedState } from '../../services/helper'
import CreateCallingScriptComponent from '../CreateCallingScriptComponent'
import CreateOrUpdatePartnerComponent from '../CreateOrUpdatePartnerComponent'
import { useHistory } from 'react-router-dom'

const FuseJsTestComponent = () => {
    const history = useHistory()

    const tabs = [
        {
            label: 'Step 1 : Upload File',
            value: 'upload',
        },
        {
            label: 'Step 2 : Mapping',
            value: 'match',
        },
        {
            label: 'Step 3 : Fuse Js Settings',
            value: 'settings',
        },
        {
            label: 'Step 3: Preview & Finish',
            value: 'preview',
        }
    ]

    const tabs1 = [
        {
            label: 'Step 1 : Upload File',
            value: 'upload',
        },
        {
            label: 'Step 2 : Fuse Js Settings',
            value: 'settings',
        }
    ]

    // Fuse JS Basic Options
    const fuseJsBasicSettings = [
        {
            name: 'isCaseSensitive',
            label: 'Is Case Sensitive',
            dataType: 'boolean',
            default: false
        },
        {
            name: 'includeScore',
            label: 'Include Score',
            dataType: 'boolean',
            default: true
        },
        {
            name: 'includeMatches',
            label: 'Include Matches',
            dataType: 'boolean',
            default: false
        },
        {
            name: 'shouldSort',
            label: 'Should Sort',
            dataType: 'boolean',
            default: true
        },
        {
            name: 'findAllMatches',
            label: 'Find All Matches',
            dataType: 'boolean',
            default: false
        },
        {
            name: 'minMatchCharLength',
            label: 'Minimum Match Character Length',
            dataType: 'number',
            default: 1
        },
        {
            name: 'operator',
            label: 'Select Operator',
            dataType: 'radio',
            default: 'or'
        }
    ]

    // Fuse JS Fuzzy Matching Options
    const fuseJsFuzzySettings = [
        {
            name: 'ignoreLocation',
            label: 'Ignore Location',
            dataType: 'boolean',
            default: false
        },
        {
            name: 'location',
            label: 'Location',
            dataType: 'number',
            default: 0
        },
        {
            name: 'threshold',
            label: 'Threshold',
            dataType: 'number',
            default: 0.6
        },
        {
            name: 'distance',
            label: 'Distance',
            dataType: 'number',
            default: 100
        },
    ]

    // Fuse JS Advanced Options
    const fuseJsAdvanceSettings = [
        // {
        //     name: 'useExtendedSearch',
        //     label: 'useExtendedSearch',
        //     dataType: 'boolean',
        //     default: false
        // },
        {
            name: 'ignoreFieldNorm',
            label: 'Ignore Field Norm',
            dataType: 'boolean',
            default: false
        },
        {
            name: 'fieldNormWeight',
            label: 'Field Norm Weight',
            dataType: 'number',
            default: 1
        }
    ]

    const fuseJsKeys = [
        {
            name: 'suppliername',
            label: 'Supplier Name'
        },
        {
            name: 'address1',
            label: 'Address 1'
        },
        {
            name: 'city',
            label: 'City'
        },
        {
            name: 'state',
            label: 'State'
        },
        {
            name: 'zip',
            label: 'Zip'
        },
        {
            name: 'email',
            label: 'Email'
        },
        {
            name: 'phone',
            label: 'Phone'
        },
        {
            name: 'employerIdNumber',
            label: 'EIN'
        },
        // {
        //     name: 'fullAddress',
        //     label: 'Full Address'
        // }
    ]

    const addressFields = ['address1', 'city', 'state', 'zip']

    const dbMatchColumns = [
        {
            name: 'partnerName',
            label: 'Partner Name'
        },
        {
            name: 'companyName',
            label: 'Company name'
        },
        {
            name: 'primaryContact',
            label: 'Primary Contact'
        },
        {
            name: 'contactPhone',
            label: 'Contact Phone'
        },
        {
            name: 'contactEmail',
            label: 'Contact Email'
        },
        {
            name: 'nameUse',
            label: 'Name Use'
        },
        {
            name: 'callingScriptId',
            label: 'Calling Script'
        }
    ]

    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        upload: { uploadedData },
        partner: { partnerNames }
    } = store

    const {
        fileName
    } = uploadedData
    const [fileData, setFileData] = useState([])
    const [currentFileName, setCurrentFileName] = useState(fileName || '')
    const [isUploadingFile, setIsUploadingFile] = useState(false)
    const [currentTab, setCurrentTab] = useState('upload')
    const [fuseJsOptions, setFuseJsOptions] = useState({})
    const [suppliernameFuseJsOptions, setSuppliernameFuseJsOptions] = useState({})
    const [emailFuseJsOptions, setEmailFuseJsOptions] = useState({})
    const [addressFuseJsOptions, setAddressFuseJsOptions] = useState({})
    const [phoneFuseJsOptions, setPhoneFuseJsOptions] = useState({})
    const [fuseJsSearchKeys, setFuseJsSearchKeys] = useState([])
    const [isProgress, setIsProgress] = useState(false)
    const [dataOption, setDataOption] = useState('importFile')
    const [manualSupplierData, setManulSupplierData] = useState({})
    const [isPhoneValid, setIsPhoneValid] = useState('')
    const [isValidatingPhone, setIsValidatingPhone] = useState(false)
    const [isEmailValid, setIsEmailValid] = useState('')
    const [isValidatingEmail, setIsValidatingEmail] = useState(false)
    const [defaultScript, setDefaultScript] = useState(null)
    const [countryCode, setCountryCode] = useState('')
    const phoneInputRefname = useRef(null);
    const [showPartnerManagement, setShowPartnerManagement] = useState(false)
    const [showCreateCallingScript, setShowCreateCallingScript] = useState(false)
    const [selectedPartner, setSelectedPartner] = useState(null)
    const [dbMatchValues, setDbmatchValues] = useState({})
    const [isRunEsMatch, setIsRunEsMatch] = useState(false)
    const [addressOption, setAddressOption] = useState('broken')
    const [isUseFullAddressMatch, setIsUseFullAddressMatch] = useState(false)

    const handleSettingsChange = (settingName, value, dataType) => {
        if (settingName === 'threshold') {
            if (parseInt(value) > 1) {
                value = 1
            }
        }
        if (dataType === 'number') {
            if ((settingName === 'threshold' || settingName === 'fieldNormWeight')) {
                value = parseFloat(value)
            } else {
                value = parseInt(value)
            }
        }
        setFuseJsOptions({ ...fuseJsOptions, [settingName]: value })
    }
    const handleSearchKeysChange = (keyName, value) => {
        let tmpKeys = [...fuseJsSearchKeys]
        let index = tmpKeys.map((e) => { return e.name; }).indexOf(keyName);
        tmpKeys[index].weight = value ? parseInt(value) : value
        setFuseJsSearchKeys(tmpKeys)
    }

    const handleDataOptionChange = (value) => {
        setDataOption(value)
    }

    const handleManualSupplierDataChange = (colName, value) => {
        let tmpValue = value
        if (colName === 'state') {
            let stateCode = getAbbreviatedState('', value)
            setManulSupplierData({ ...manualSupplierData, [colName]: value, 'abbreviatedState': stateCode })
        } else if (colName === 'employerIdNumber') {
            if (value.length === 3 && value.includes('-')) {
                value = value.replaceAll('-', '')
            } else if (value.length === 2 || value.length === 3) {
                if (value.length === 3) {
                    value = value.substring(0, 2) + '-' + value.substring(2)
                } else {
                    value += '-'
                }
            }
            if (/^\d{2}(-\d{7})?$/.test(value)) {
                tmpValue = value
            } else {
                tmpValue = value.match(/^\d{1,2}(-\d{0,7})?/gi) ? value.match(/^\d{1,2}(-\d{0,7})?/gi)[0] : ''
            }
            setManulSupplierData({ ...manualSupplierData, [colName]: tmpValue })
        } else {
            setManulSupplierData({ ...manualSupplierData, [colName]: value })
        }
    }

    useEffect(() => {
        const tmpOptions = {}
        const tmpSearchKeys = []
        fuseJsBasicSettings.map((setting) => {
            tmpOptions[setting.name] = setting.default
        })
        fuseJsFuzzySettings.map((setting) => {
            tmpOptions[setting.name] = setting.default
        })
        fuseJsAdvanceSettings.map((setting) => {
            tmpOptions[setting.name] = setting.default
        })
        fuseJsKeys.map((key) => {
            tmpSearchKeys.push({ name: key.name, weight: 1 })
        })
        const tmpData = {}
        dbMatchColumns.map(col => {
            tmpData[col.name] = col?.name === 'nameUse' ? null : ''
        })
        setDbmatchValues(tmpData)
        setFuseJsOptions(tmpOptions)
        setSuppliernameFuseJsOptions(tmpOptions)
        setEmailFuseJsOptions(tmpOptions)
        setAddressFuseJsOptions(tmpOptions)
        setPhoneFuseJsOptions(tmpOptions)
        setFuseJsSearchKeys(tmpSearchKeys)
    }, [])

    const handleFileChosen = (file) => {
        if (
            !file ||
            !(file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'text/csv')
        ) {
            toast.show({
                title: 'Warning',
                description: 'File type should be .csv, .xls or xlsx!'
            })
            return
        }
        setIsUploadingFile(true)
        ExcelRenderer(file, (err, resp) => {
            if (err) {
                setIsUploadingFile(false)
            } else {
                loadUploadedFileContent(resp.rows, file.name)
            }
        })
    }

    const loadUploadedFileContent = (data, fileName) => {
        if (data.length === 0) {
            setIsUploadingFile(false)
            return
        }
        const cols = data.shift()
        const count = {}
        const duplicatedItems = []

        cols.forEach(col => {
            if (count[col]) {
                count[col] += 1
                return
            }
            count[col] = 1
        })

        for (let prop in count) {
            if (count[prop] >= 2) {
                duplicatedItems.push(prop)
            }
        }

        if (duplicatedItems.length > 0) {
            toast.show({
                title: 'Warning',
                description: `Column${duplicatedItems.length > 1 ? 's' : ''}: ${duplicatedItems.join(', ')} ${duplicatedItems.length > 1 ? 'are' : 'is'} duplicated! Please use unique column name.`
            })
            setIsUploadingFile(false)
            return
        }

        const tableData = []
        data.forEach(row => {
            const rowData = {}
            cols.forEach((col, index) => {
                rowData[col] = row[index]
            })
            tableData.push(rowData)
        })

        setCurrentFileName(fileName)
        handleUploadData(cols, tableData, fileName)
        setFileData(tableData)
        setIsUploadingFile(false)
    }

    const handleUploadData = (cols, data, fileName) => {
        const tmpData = {}
        dbMatchColumns.map(col => {
            tmpData[col.name] = col?.name === 'nameUse' ? null : ''
        })
        setDbmatchValues(tmpData)
        dispatch(
            uploadData({
                cols,
                data,
                fileName,
            })
        )
    }

    const handleClickClear = () => {
        dispatch(
            clearUploadData()
        )
        setCurrentFileName('')
    }

    const handleClickTab = (tab, isRunEsMatch = false, isUseFullAddressMatch = false) => {
        setCurrentTab(tab)
        setIsRunEsMatch(isRunEsMatch)
        setIsUseFullAddressMatch(isUseFullAddressMatch)
    }

    const handleOnConfirm = (tableData, cols) => {
        const matchedColumns = ["suppliername", "address1", "city", "state", "zip", "phone", "email", "employerIdNumber"]
        const defaultCols = cols?.filter(col => col?.matchedName && matchedColumns?.includes(col?.matchedName))

        const tableColumns = [...defaultCols]
        if (isRunEsMatch) {
            tableColumns.push(
                { originalName: 'ES Score', matchedName: 'esscore' },
                { originalName: 'ES Matched Id', matchedName: 'esmatchedId' },
                { originalName: 'ES Matched Supplier Name', matchedName: 'esmatchedSuppliername' },
                { originalName: 'ES Matched Supplier Address', matchedName: 'esmatchedAddress' },
                { originalName: 'ES Matched Supplier City', matchedName: 'esmatchedCity' },
                { originalName: 'ES Matched Supplier State', matchedName: 'esmatchedState' },
                { originalName: 'ES Matched Supplier Zip', matchedName: 'esmatchedZip' },
                { originalName: 'ES Matched Supplier Email', matchedName: 'esmatchedEmail' },
                { originalName: 'ES Matched Supplier Phone', matchedName: 'esmatchedPhone' },
                { originalName: 'ES Matched Supplier EIN', matchedName: 'esmatchedEIN' }
            )
        } else {
            tableColumns.push(
                { originalName: 'score', matchedName: 'score' },
                { originalName: 'Matched Id', matchedName: 'matchedId' },
                { originalName: 'Matched Supplier Name', matchedName: 'matchedSuppliername' },
                { originalName: 'Matched Supplier Address', matchedName: 'matchedAddress' },
                { originalName: 'Matched Supplier City', matchedName: 'matchedCity' },
                { originalName: 'Matched Supplier State', matchedName: 'matchedState' },
                { originalName: 'Matched Supplier Zip', matchedName: 'matchedZip' },
                { originalName: 'Matched Supplier Email', matchedName: 'matchedEmail' },
                { originalName: 'Matched Supplier Phone', matchedName: 'matchedPhone' },
                { matchedName: 'matchedEIN', originalName: 'Matched Supplier EIN' },
                { originalName: 'Match Status', matchedName: 'matchStatus' },
                { originalName: 'ES Score', matchedName: 'esscore' },
                { originalName: 'ES Matched Id', matchedName: 'esmatchedId' },
                { originalName: 'ES Matched Supplier Name', matchedName: 'esmatchedSuppliername' },
                { originalName: 'ES Matched Supplier Address', matchedName: 'esmatchedAddress' },
                { originalName: 'ES Matched Supplier City', matchedName: 'esmatchedCity' },
                { originalName: 'ES Matched Supplier State', matchedName: 'esmatchedState' },
                { originalName: 'ES Matched Supplier Zip', matchedName: 'esmatchedZip' },
                { originalName: 'ES Matched Supplier Email', matchedName: 'esmatchedEmail' },
                { originalName: 'ES Matched Supplier Phone', matchedName: 'esmatchedPhone' },
                { originalName: 'ES Matched Supplier EIN', matchedName: 'esmatchedEIN' }
            )
        }

        setIsProgress(true)
        const suppliernameOptions = { ...suppliernameFuseJsOptions }
        const addressOptions = { ...addressFuseJsOptions }
        const emailOptions = { ...emailFuseJsOptions }
        const phoneOptions = { ...phoneFuseJsOptions }
        const options = { ...fuseJsOptions }
        let keys = [...fuseJsSearchKeys]
        keys = keys.sort(function (a, b) {
            return b.weight - a.weight;
        });

        suppliernameOptions['keys'] = ["suppliername"]
        addressOptions['keys'] = ["address1", "address2", "city", "state", "zip"]
        emailOptions['keys'] = ["email"]
        phoneOptions['keys'] = ["phone"]
        options['keys'] = keys
        dispatch(testFuseJsSettings({
            data: tableData,
            fuseJsOptions: options,
            isRunEsMatch: isRunEsMatch,
            isUseFullAddressMatch: isUseFullAddressMatch
        })).then(result => {
            setIsProgress(false)
            const exportData = [tableColumns.map(column => {
                if (column.name === 'suppliersMatched') {
                    return 'Total Suppliers Matched'
                } else {
                    return column.originalName
                }
            })]
            exportData.push(...result.map(row => {
                return tableColumns.map(column => {
                    if (column.matchedName) {
                        if (row?.data[column.matchedName] && typeof row?.data[column.matchedName] === 'string') {
                            return row?.data[column.matchedName].replaceAll('#', '').replaceAll(',', '')
                        } else {
                            return row?.data[column.matchedName]
                        }
                    } else {
                        return ''
                    }
                }
                )
            }))
            // Export all matched and unmatched data
            let csvContent = "data:text/csv;charset=utf-8,"
            exportData.forEach((row, index) => {
                const dataString = row.join(',')
                csvContent += index < exportData.length ? dataString + '\n' : dataString
            })
            const downloadElement = document.createElement('a')
            downloadElement.setAttribute('href', encodeURI(csvContent))
            downloadElement.setAttribute('download', `${uploadedData.fileName || 'supplier'}.csv`)
            downloadElement.click()
        }).catch(err => {
            setIsProgress(false)
        })
    }

    const handleDbMatchValuesUpdate = (colName, value) => {
        let tmpValue = value
        if (colName === 'contactEmail') {
            if (!tmpValue) {
                setIsEmailValid(true)
            } else {
                setIsEmailValid('')
            }
        } else if (colName === 'contactPhone') {
            tmpValue = value
            setIsPhoneValid(false)
        } else if (colName === 'partnerName') {
            let contactNameVal = partnerNames?.find(val => val.partnerName === tmpValue)
            let callingScripts = partnerNames?.find(val => val?.partnerName === tmpValue)?.callingScripts
            let defaultScript = callingScripts?.find(script => script?.isDefault)
            setDefaultScript(defaultScript ? defaultScript : null)
            setDbmatchValues({
                ...dbMatchValues, [colName]: tmpValue, primaryContact: contactNameVal?.contactName || '', callingScriptId: defaultScript ? {
                    label: defaultScript?.title,
                    value: defaultScript?.id
                } : null
            })
            return
        }
        setDbmatchValues({ ...dbMatchValues, [colName]: tmpValue })
    }

    const handlePhoneNumberFocusOut = async (event, country, phoneValue, isUseEffect = false) => {
        var countryCode = country && country.dialCode
        var phoneValueWithCode = phoneValue
        var testPhone = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
        if (testPhone !== '' && testPhone !== countryCode && !/^(\d{1,}|[(]?[0-9]+[)])?([-]?[\s]?[0-9]){10}$/i.test(testPhone)) {
            setIsPhoneValid(false)
            toast.show({
                title: 'Warning',
                description: 'Please enter valid phone number!'
            })
            return
        }

        if ((event && event.type === 'blur' && event.relatedTarget !== null && event.relatedTarget.classList.value === 'selected-flag') || (countryCode === phoneValueWithCode.replace(/^\s*(?:\+)/, ''))) {
            return
        }
        if (phoneValue !== '') {
            setIsValidatingPhone(true)
            phoneValue = phoneValue.replace(/^\s*(?:\+?(\d{1,4})\s)?/, '').replace(/[^\w\s]|[\s]/gi, '')
            var phoneValidationResult = await checkIsPhoneNumberValid(phoneValue, phoneValueWithCode, dispatch)
            setIsPhoneValid(phoneValidationResult?.isPhoneValid)
            setIsValidatingPhone(phoneValidationResult?.isValidatingPhone)
        } else {
            setIsPhoneValid(true)
        }
    }

    const handlePhoneInputChange = (value, country, e, formattedValue) => {
        var phoneValue = formattedValue.replace(/^\s*(?:\+?(\d{1,4}))\s?/, '').replace(/[^\w\s]|[\s]/gi, '')
        var countrycode = country.dialCode + ' '
        if (phoneValue !== '') {
            phoneValue = countrycode + phoneValue
            setIsPhoneValid('')
        } else {
            phoneValue = country.dialCode
            setIsPhoneValid(true)
        }
        if (e.target === null) {
            handlePhoneNumberFocusOut(e, country, formattedValue)
        }
        setCountryCode(country.dialCode)
        setDbmatchValues({
            ...dbMatchValues,
            'contactPhone': phoneValue === '' ? '' : phoneValue,
        })
    }

    const handleKeyDown = (e, phoneInputRefname) => {
        if (e.keyCode === 9) {
            phoneInputRefname.current.props.onBlur()
        }
    }

    const handleEmailFocusOut = async (emailValue) => {
        if (emailValue && emailValue !== '' && !/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/.test(emailValue)) {
            setIsEmailValid(false)
            toast.show({
                title: 'Warning',
                description: 'Email Address must be in email format!'
            })
            return
        }
        if (emailValue && emailValue !== '') {
            setIsValidatingEmail(true)
            var emailValidationResult = await checkIsEmailValid(emailValue, dispatch)
            setIsEmailValid(emailValidationResult?.isEmailValid)
            setIsValidatingEmail(emailValidationResult?.isValidatingEmail)
        } else {
            setIsEmailValid(true)
        }
    }

    const handleHideShowPartnerManagement = (value) => {
        value === false && history.push('/upload')
        setShowPartnerManagement(value)
    }

    const handleShowCreateCallingScript = (value) => {
        value === false && history.push('/upload')
        let partner = partnerNames.find(val => val.partnerName === dbMatchValues?.partnerName)
        if (value && !partner?.id) {
            toast.show({
                title: 'Warning',
                description: 'Please select partner name!'
            })
            return
        }
        setSelectedPartner(partner)
        setShowCreateCallingScript(value)
    }

    const handleAddressOption = (value) => {
        if (value === 'full') {
            const tmpOptions = { ...manualSupplierData }
            tmpOptions.address1 = ''
            tmpOptions.city = ''
            tmpOptions.state = ''
            tmpOptions.zip = ''
            setManulSupplierData(tmpOptions)
        } else {
            setManulSupplierData({ ...manualSupplierData, fullAddress: '' })
        }
        setAddressOption(value)
    }

    let tmpTabs = dataOption === 'manual' ? tabs1 : tabs

    return (
        showPartnerManagement ? (
            <CreateOrUpdatePartnerComponent
                OnHidePartnerManagement={handleHideShowPartnerManagement}
            />
        ) :
            showCreateCallingScript ?
                <CreateCallingScriptComponent
                    onShowCreateCallingScript={handleShowCreateCallingScript}
                    partnerId={selectedPartner?.id}
                    defaultScript={defaultScript}
                    partnerName={selectedPartner ? selectedPartner?.partnerName : ''}
                />
                :
                <div className='test-page padding-left d-flex flex-column upload-component'>
                    <div className='upload-header'>
                        {
                            tmpTabs.map((tab, index) => {
                                return (
                                    <button
                                        type="button"
                                        onClick={() => { handleClickTab(tab.value) }}
                                        className={`upload-tab d-flex align-items-center ${currentTab === tab.value ? 'selected' : ''}`}
                                        key={tab.value}
                                    >
                                        {tab.label}
                                        {index === tmpTabs.length - 1 ? '' : <span>{'>'}</span>}
                                    </button>
                                )
                            })
                        }
                    </div>
                    <div className={`upload-body`}>
                        {currentTab === 'upload' && (
                            <>
                                <div className='d-flex align-items-center'>
                                    <RadioGroup name="radioList" className='flex' inline={true} value={dataOption}>
                                        <Radio className='h4 mb-0 text-black' value="importFile" onChange={() => { handleDataOptionChange('importFile') }}>Import File</Radio>
                                        <Radio className='h4 mb-0 text-black' value="manual" onChange={() => { handleDataOptionChange('manual') }}>Set Fields Manually</Radio>
                                    </RadioGroup>
                                </div>
                                {dataOption === 'importFile' && (
                                    <div className='d-flex flex-column'>
                                        <div className={`upload-tab gap-5 d-flex align-items-center flex-column flex-md-row mt-5 shadow-lg p-5 rounded`}>
                                            <div className={`w-50 upload-action d-flex flex-column position-relative gap-4 ${isUploadingFile && 'loading'}`}>
                                                {isUploadingFile && <LoaderComponent />}
                                                <DragDropFileUpload
                                                    currentFileName={currentFileName}
                                                    onFileChosen={handleFileChosen}
                                                    customClassName='upload-vendor-file h-50'
                                                />
                                                {
                                                    fileName ? <button type="button" className="rounded p-3 w-25 align-self-center bg-red h4 mb-0 text-white" onClick={handleClickClear}>Remove</button>
                                                        : <span className='h4 mb-0 align-self-center'>.csv, .xls and .xlsx files accepted</span>
                                                }
                                            </div>
                                            <div className="upload-note h4 mb-0 w-50 align-self-center">
                                                You can upload any .csv, .xls, .xlsx file with any set of columns as long as it has 1 record per row. The next step will allow you to match your spreadsheet to the right datapoint. You'll be able to clean up or remove any corrupted data before finalizing your report.
                                            </div>
                                        </div >
                                        {fileName && (
                                            <button type="button" className="bg-green rounded p-3 ps-5 pe-5 text-white h4 mb-0 mt-4 ms-auto position-sticky bottom-0" onClick={() => { handleClickTab('match') }}>
                                                Continue
                                            </button>
                                        )}
                                    </div>
                                )}
                                {dataOption === 'manual' && (
                                    <div className='d-flex flex-column gap-4'>
                                        <div className='d-flex flex-column gap-4 mt-5'>
                                            {fuseJsKeys.map((key, ind) => (
                                                <div className='d-flex gap-4 align-items-center'>
                                                    <h4 className='mb-0 w-25 text-black fw-bold'>{key.label}</h4>
                                                    <input className='search-input h4 mb-0' value={manualSupplierData?.[key.name]} onChange={(e) => { handleManualSupplierDataChange(key.name, e.target.value) }} />
                                                </div>
                                            ))}
                                        </div>
                                        <button type="button" className="bg-green rounded p-3 ps-5 pe-5 text-white h4 mb-0 mt-4 ms-auto position-sticky bottom-0" onClick={() => { handleClickTab('settings') }}>
                                            Continue
                                        </button>
                                    </div>
                                )}
                            </>
                        )}

                        {currentTab === 'match' && (
                            <MatchComponent
                                onGoBack={handleClickTab}
                                onContinue={handleClickTab}
                                isTest={true}
                                dbMatchColumns={dbMatchColumns}
                                dbMatchDataValues={dbMatchValues}
                                onChangeDbMatchValues={handleDbMatchValuesUpdate}
                                onEmailFocusOut={handleEmailFocusOut}
                                onKeyDown={handleKeyDown}
                                onPhoneInputChange={handlePhoneInputChange}
                                onPhoneNumberFocusOut={handlePhoneNumberFocusOut}
                                phoneInputRefname={phoneInputRefname}
                                isValidatingPhone={isValidatingPhone}
                                isPhoneValid={isPhoneValid}
                                isValidatingEmail={isValidatingEmail}
                                isEmailValid={isEmailValid}
                                onShowPartnerManagement={handleHideShowPartnerManagement}
                                onShowCreateCallingScript={handleShowCreateCallingScript}
                                setDbmatchValues={setDbmatchValues}

                            />
                        )}
                        {currentTab === 'settings' && (
                            <FuseJsSettings
                                fuseJsBasicSettings={fuseJsBasicSettings}
                                fuseJsFuzzySettings={fuseJsFuzzySettings}
                                fuseJsAdvanceSettings={fuseJsAdvanceSettings}
                                fuseJsOptions={fuseJsOptions}
                                fuseJsKeys={fuseJsKeys}
                                fuseJsSearchKeys={fuseJsSearchKeys}
                                handleSearchKeysChange={handleSearchKeysChange}
                                handleSettingsChange={handleSettingsChange}
                                onContinue={handleClickTab}
                                onGoBack={handleClickTab}
                                dataOption={dataOption}
                                manualSupplierData={manualSupplierData}
                            />
                        )}
                        {currentTab === 'preview' && (
                            <div className={`position-relative ${isProgress ? 'loading' : ''}`}>
                                {isProgress && <LoaderComponent />}
                                <PreviewComponent
                                    onGoBack={handleClickTab}
                                    isTest={true}
                                    onConfirm={handleOnConfirm}
                                    dbMatchValues={dbMatchValues}
                                />
                            </div>
                        )}
                    </div>
                </div >
    )
}

export default FuseJsTestComponent